export default "__VITE_PUBLIC_ASSET__8ac8d3e8__"